import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['destination', 'product', 'count', 'submit'];

  connect() {
    this.PRODUCTS_SELECT_SEARCH_BASE_URL = '/sandbar/admin/products/select_search';
  }

  handleDestinationChanged() {
    if (!this.destinationTarget.value) {
      this.disableFields();
    } else {
      let currentProductOptionsURL = this.productTarget.dataset.optionsUrl;
      let computedProductOptionsURL = this.productsUrlWithDestinationID();
      if (currentProductOptionsURL !== computedProductOptionsURL) {
        this.updateProductOptionsUrl();
      }
    }
  }

  updateProductOptionsUrl() {
    this.enableFields();
    this.productTarget.dataset.optionsUrl = this.productsUrlWithDestinationID();
    this.productTarget.dispatchEvent(new CustomEvent('select2:reinitialize!'));
  }

  productsUrlWithDestinationID() {
    return `${this.PRODUCTS_SELECT_SEARCH_BASE_URL}?destination_id=${this.destinationTarget.value}`;
  }

  disableFields() {
    // this controller is used both on the Index and New views,
    // On new when need to disable and enable fields depending on selections made, On index we do not,
    // if the count target is present (new view only) disable / enable (below) the fields.
    if (this.hasCountTarget) {
      this.productTarget.disabled = true;
      this.countTarget.disabled = true;
      this.submitTarget.disabled = true;
    }
  }

  enableFields() {
    if (this.hasCountTarget) {
      this.productTarget.disabled = false;
      this.countTarget.disabled = false;
      this.submitTarget.disabled = false;
    }
  }
}
